import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as CONST from '../../../../../constants/FieldsConst';
import { dateformat, textLabels } from '../../../../../helpers';
import { useNotification } from '../../../../../helpers/Notification';
import * as ROUTES from '../../../../../router/Routes';
import { LoadingWidget } from '../../../../../widgets';
import ActionsListWidget from '../../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../../widgets/modals/DeleteModal';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import { NameComponent } from '../../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allPlanEvaluacionAction,
  deletePlanEvaluacionAction,
  setActivoPlanEvaluacionAction,
  updateEstatusPlanEvaluacionAction,
} from '../PlanEvaluacionAction';
import { PARAMS_PLAN_EVALUACION } from '../PlanEvaluacionReducer';

const ListadoPlanEvaluacion = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const docentesStore = Redux.useSelector((state) => state.docentes);
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  let intervalSearch = null;

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        idEntidad: entidadesStore.activo.id,
        idPeriodoAcademico: entidadesStore.ajustes.periodoAcademico.id,
        idDocente: loginStore.isTeacher ? docentesStore.activo.id : null,
        ...planEvaluacionStore.params,
      };
      dispatch({ type: PARAMS_PLAN_EVALUACION, payload });
      if (planEvaluacionStore.all.length === 0) {
        await allPlanEvaluacionAction(dispatch, payload);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const fetchData = () => {
      const rowsData = [];
      planEvaluacionStore.all.forEach((el) => {
        rowsData.push({
          ...el,
          materia: el.materia.nombre,
          seccion: el.seccion.nombre,
          fecha: `${dateformat(el.fechaBloque.desde, {
            inverse: true,
          })} - ${dateformat(el.fechaBloque.hasta, { inverse: true })}`,
          nivelAcademico: el.seccion.nivelAcademico.nivelAcademico.nombre,
          bloquePedagogico: {
            bloque: el.fechaBloque.bloquePedagogico.nombre,
            docente: loginStore.isTeacher
              ? null
              : `${el.docente.usuario.perfil.pnombre} ${el.docente.usuario.perfil.papellido}`,
          },
          estatus: el.estatus.nombre,
          actions: el,
        });
      });
      setRows(rowsData);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planEvaluacionStore.all]);

  const _handleEditClick = async (id) => {
    const data = planEvaluacionStore.all.find((el) => el.id === id);
    await setActivoPlanEvaluacionAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deletePlanEvaluacionAction(
      { dispatch, notify },
      planEvaluacionStore.activo.id,
      planEvaluacionStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
    setLoadingDelete(false);
  };

  const updateEstatusHandler = async (id, idEstatus) => {
    await updateEstatusPlanEvaluacionAction(
      { dispatch, notify },
      id,
      {
        idEntidad: entidadesStore.activo.id,
        idEstatus,
      },
      planEvaluacionStore.params,
      planEvaluacionStore.activo,
    );
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.bloquePedagogico.name,
      label: CONST.bloquePedagogico.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack>
              <NameComponent
                onClick={() => {
                  const data = planEvaluacionStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  setActivoPlanEvaluacionAction(dispatch, data);
                  history.push(ROUTES.panelPlanEvaluacion.to);
                }}
              >
                {value.bloque}
              </NameComponent>
              {value.docente && (
                <Typography variant="subTitle1" color="initial">
                  <strong>Docente: </strong>
                  {value.docente}
                </Typography>
              )}
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.fecha.name,
      label: CONST.fecha.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.materia.name,
      label: CONST.materia.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.nivelAcademico.name,
      label: CONST.nivelAcademico.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.seccion.name,
      label: CONST.seccion.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={value === 'ACTIVO' ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <BotonComponent
                click={() => {
                  const data = planEvaluacionStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  setActivoPlanEvaluacionAction(dispatch, data);
                  history.push(ROUTES.panelPlanEvaluacion.to);
                }}
                icon
                size="medium"
                transparentBg
                dashboardIcon
                tooltip="Panel de gestión"
              />
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  await setActivoPlanEvaluacionAction(dispatch, value);
                  setOpenModalDelete(true);
                }}
                onActivar={
                  value.estatus.id === 2
                    ? async () => {
                        updateEstatusHandler(value.id, 1);
                      }
                    : null
                }
                onBloquear={
                  value.estatus.id === 1
                    ? async () => {
                        updateEstatusHandler(value.id, 2);
                      }
                    : null
                }
                onDownload={() => {
                  const data = planEvaluacionStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  window.open(data.url);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },

    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
    serverSide: true,
    onSearchChange: (searchQuery) => {
      if (searchQuery) {
        clearTimeout(intervalSearch);
        intervalSearch = setTimeout(() => {
          const payload = {
            ...planEvaluacionStore.params,
            q: searchQuery,
          };
          dispatch({ type: PARAMS_PLAN_EVALUACION, payload });
          allPlanEvaluacionAction(dispatch, payload);
        }, 800);
      }
    },
  };

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={
            planEvaluacionStore.loadingAll ||
            loadingDelete ||
            planEvaluacionStore.loadingUpdateEstatus
          }
          text={
            planEvaluacionStore.loadingUpdateEstatus
              ? 'Actualizando estatus del registro...'
              : null
          }
        />
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {planEvaluacionStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            Plan de evaluación de la materia{' '}
            <strong>{planEvaluacionStore.activo.materia.nombre}</strong>
            de la sección{' '}
            <strong>{planEvaluacionStore.activo.seccion.nombre}</strong> del
            bloque{' '}
            <strong>
              {planEvaluacionStore.activo.fechaBloque.bloquePedagogico.nombre}
            </strong>
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoPlanEvaluacion;
